const CONTINUE_CARD_DIMENSIONS = {
  modal: { width: 144, height: 81 },
  xs: { width: 204, height: 115 },
  sm: { width: 316, height: 178 },
  md: { width: 298, height: 168 },
  lg: { width: 345, height: 194 },
  xxl: { width: 345, height: 194 },
}

const CONTINUE_CARD_DIMENSIONS_MODAL = {
  xs: { width: 350, height: 81 },
  sm: { width: 576, height: 81 },
  md: { width: 1000, height: 81 },
  lg: { width: 1440, height: 81 },
  xxl: { width: 1400, height: 81 },
}

// sem dimensões em 'xs' e 'sm', pra não quebrar a tipagem
const CONTINUE_CARD_DIMENSIONS_DESKTOP_WEB = {
  xs: { width: 0, height: 0 },
  sm: { width: 0, height: 0 },
  md: { width: 947, height: 81 },
  lg: { width: 1208, height: 81 },
  xxl: { width: 1395, height: 81 },
}

export {
  CONTINUE_CARD_DIMENSIONS,
  CONTINUE_CARD_DIMENSIONS_MODAL,
  CONTINUE_CARD_DIMENSIONS_DESKTOP_WEB,
}
